// import $ from 'jquery'
//
// const opts = {
//   owlPrev: '.owl-prev-news',
//   owlNext: '.owl-next-news',
//   owlItem: '.owl-item-news',
//   owlPlay: '.owl-play-news',
// 	owlPause: '.owl-pause-news',
//   jsSelector: '.owl-carousel-news',
//   owlOpts: {
//     nav: false,
//     // navText: ['precedente', 'successivo'],
//     autoHeight: true,
//     dots: true,
//     loop: true,
//     autoplay: true,
//     autoplayTimeout: 9000,
//     autoplayHoverPause: true,
//     lazyLoad: true,
//     items: 1,
//     margin: 16,
//     mouseDrag: true,
//     URLhashListener: true,
//     controlsClass: '.owl-controls-custom',
// 	  dotsContainer: '.owl-controls-custom-dots',
//     startPosition: 'URLHash',
//     responsive: {
//       0: {
//         items: 1
//       },
//       768: {
//         items: 1
//       },
//       992: {
//         items: 1
//       }
//     }
//   }
// }
//
// const init2 = function() {
//   const $owl = $(opts.jsSelector)
//
//   if ($owl.length <= 0) {
//     return
//   }
//
//   require(['owl.carousel', './a11y', 'owl.carousel/dist/assets/owl.carousel.css'], () => {
//     $(opts.owlPrev).click(() => $owl.trigger('prev.owl.carousel'))
//     $(opts.owlNext).click(() => $owl.trigger('next.owl.carousel'))
//     $(opts.owlPlay).click(() => $owl.trigger('play.owl.autoplay',[9000]))
//     $(opts.owlPause).click(() => $owl.trigger('stop.owl.autoplay'))
//
//     $(opts.owlPlay).click(function(){
//       // $(this).toggleClass('is-active')
//       // if ($(opts.owlPause).hasClass('is-active')) {
//       //   $(opts.owlPause).removeClass('is-active')
//       // } else {
//       //   $(opts.owlPause).addClass('is-active')
//       // }
//     })
//
//     $(opts.owlPause).click(function(){
//       // $(this).toggleClass('is-active')
//       // if ($(opts.owlPlay).hasClass('is-active')) {
//       //   $(opts.owlPlay).removeClass('is-active')
//       // } else {
//       //   $(opts.owlPlay).addClass('is-active')
//       // }
//     })
//
//     $owl.on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel', (event) => {
//       if (!event.namespace) return
//
//       var carousel = event.relatedTarget,
//         element = event.target,
//         current = carousel.current()
//
//       $(`${opts.owlNext}[aria-controls='${element.id}']`)
//         .toggleClass('u-visibilityHidden', current === carousel.maximum())
//
//       $(`${opts.owlPrev}[aria-controls='${element.id}']`)
//         .toggleClass('u-visibilityHidden', current === carousel.minimum())
//     })
//
//     const settings = $.extend({}, opts.owlOpts || {}, $owl.data('carouselOptions'))
//
//     // must be called after events initialization
//     $owl.owlCarousel(settings)
//   })
// }
//
// $(document).ready(init2)
//
// export default {
//   opts,
//   init2
// }



// WEBPACK FOOTER //
// ./src/components/carouselnews/index.js